import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon, iconsList } from "../../Icon";
import { Card } from "../Card";
import styles from "./SecondaryCard.module.scss";

const SecondaryCard = ({
	className,
	style,
	image,
	header,
	subheader,
	link,
	button,
	horizontal,
	renderImage,
	renderLink,
}) => (
	<Card className={cx(styles.secondary, className, horizontal && styles.horizontal)} style={style}>
		{image && (
			<Card.Image
				className={cx(styles.secondaryImage)}
				src={image?.src}
				alt={image?.alt}
				imageComponentProps={{ renderImage }}
			/>
		)}
		<Card.Body className={cx(styles.secondaryBody)}>
			<Card.Header size="h5" className={cx(styles.secondaryHeading)}>
				{header}
			</Card.Header>
			{subheader && (
				<Card.Subheader className={cx(styles.secondarySubheading)}>{subheader}</Card.Subheader>
			)}
			{link?.to && (
				<Card.Link
					className={cx(styles.secondaryLink)}
					to={link?.to}
					target={link?.target}
					renderLink={renderLink}>
					<span className={cx(styles.secondaryLinkText)}>
						{link?.text} <Icon name="arrow-right" className={styles.secondaryLinkTextIcon} />
					</span>
				</Card.Link>
			)}
			{button?.onClick && (
				<div>
					<Card.Button
						className={cx(styles.secondaryButtonLink)}
						icon={button?.icon}
						iconPlacement={button?.iconPlacement}
						onClick={button?.onClick}
						linkComponentProps={{ renderLink }}>
						{button?.text}
					</Card.Button>
				</div>
			)}
		</Card.Body>
		{link?.to && (
			<Card.AsLink
				link={link.to}
				target={link?.target}
				text={header || link?.text}
				className={cx(styles.secondaryCardLink)}
				renderLink={renderLink}
			/>
		)}
		{button?.to && (
			<Card.AsLink
				link={button.to}
				target={button?.target}
				text={button.text}
				className={cx(styles.secondaryCardLink)}
				renderLink={renderLink}
			/>
		)}
	</Card>
);

SecondaryCard.propTypes = {
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	image: PropTypes.shape({
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
	}),
	header: PropTypes.string.isRequired,
	subheader: PropTypes.string,
	link: PropTypes.shape({
		to: PropTypes.string.isRequired,
		target: PropTypes.string,
		icon: PropTypes.oneOf(iconsList),
		text: PropTypes.string,
	}),
	button: PropTypes.shape({
		to: PropTypes.string,
		onClick: PropTypes.func,
		target: PropTypes.string,
		icon: PropTypes.oneOf(iconsList),
		iconPlacement: PropTypes.oneOf(["right", "left"]),
		outline: PropTypes.bool,
		className: PropTypes.string,
		text: PropTypes.string,
	}),
	horizontal: PropTypes.bool,
	renderImage: PropTypes.func,
	renderLink: PropTypes.func,
};

SecondaryCard.defaultProps = {
	className: "",
	style: {},
	image: null,
	subheader: null,
	link: null,
	button: undefined,
	horizontal: false,
	renderImage: undefined,
	renderLink: undefined,
};

export default SecondaryCard;
export { SecondaryCard };
